import { render, staticRenderFns } from "./TitularidadeIngressoView.vue?vue&type=template&id=3d0e81bf&scoped=true"
import script from "./TitularidadeIngressoView.vue?vue&type=script&lang=js"
export * from "./TitularidadeIngressoView.vue?vue&type=script&lang=js"
import style0 from "./TitularidadeIngressoView.vue?vue&type=style&index=0&id=3d0e81bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e81bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
